export default __webpack_public_path__ + "static/media/image-header.9167cda0.jpg";